import { useMutation } from 'react-query';
import { BASE_API_URL } from '@env';

export function useLogin() {
  return useMutation(async ({ email, password }: { email: string; password: string }) => {
    console.log(BASE_API_URL);
    
    const response = await fetch(`${BASE_API_URL}users/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Login failed');
    }
    return response.json();
  });
} 